import util from "./_util";

const { request } = util;

export default {
  //发布评论
  publishComment(data) {
    return request.post("/comment/add", data);
  },
  //分页查询评论
  queryComments(params) {
    return request.get("/comment/pager_list", {
      params,
    });
  },
  //点赞
  thumbComment(data) {
    return request.post("/comment/prize", data);
  },
};
